import { PageHelmet } from 'components/common/PageHelmet';
import { useState } from 'react';
import { StaffLayout } from './StaffLayout';
import { useCommonTranslation } from '../../hooks/i18n/useCommonTranslation';
import { StaffAppointmentsCard } from './appointments/StaffAppointmentsCard';
import { useFlowEditAppointment } from '../../hooks/staff/useFlowEditAppointment';
import { PatientAppointmentsAndEditPatientControl } from './appointments/PatientAppointmentsAndEditPatientControl';
import { useAppointmentsFlow } from '../../hooks/staff/useAppointmentsFlow';
import { SangixMainGrid } from './SangixMainGrid';
import { SearchPatientForm } from '../../components/views-components/staff/search-patient/SearchPatientForm';
import { CardDividerHeaderSection } from '../../components/common';
import { PatientDetailCard } from './calendar/bookWithPatient/PatientDetailCard';
import { BookOverflow } from './calendar/overflow/BookOverflow';
import { SearchPatientList } from '../../components/views-components/staff/search-patient/SearchPatientList';
import { useSearchAndSelectPatient } from '../../components/views-components/staff/search-patient/SearchPatientHooks';

export default function StaffAppointments() {
  const { t } = useCommonTranslation();

  const { appointmentsData, ...rest } = useAppointmentsFlow({
    showAbbreviatedNames: false,
  });

  const {
    setOrToggleEditFlowAppointmentID,
    appointment,
    mode,
    editAppointmentId,
    ...restEditPatientProps
  } = useFlowEditAppointment({
    appointmentsData,
  });

  const {
    isSearchingPatients,
    selectPatient,
    selectedPatient,
    searchPatientFormProps,
    searchPatientListProps,
  } = useSearchAndSelectPatient();

  const [overflowOpened, setOverflowOpened] = useState(false);

  return (
    <StaffLayout>
      <PageHelmet title={t('appointments')} />
      {isSearchingPatients ? (
        <SearchPatientList {...searchPatientListProps} />
      ) : (
        <SangixMainGrid
          main={
            <StaffAppointmentsCard
              printable
              setOrToggleEditAppointmentId={setOrToggleEditFlowAppointmentID}
              appointmentsData={appointmentsData}
              editAppointmentId={editAppointmentId}
              onOverflowClicked={() => setOverflowOpened(true)}
              topElement={
                <CardDividerHeaderSection
                  style={{ padding: 0, marginBottom: 'var(--s3)' }}
                >
                  <SearchPatientForm {...searchPatientFormProps} />
                </CardDividerHeaderSection>
              }
              {...rest}
            />
          }
          secondary={
            overflowOpened ? (
              <BookOverflow
                closeForm={() => {
                  selectPatient(undefined);
                  setOverflowOpened(false);
                }}
                selectedPatient={selectedPatient}
              />
            ) : selectedPatient ? (
              <PatientDetailCard
                key={selectedPatient.id}
                patient={selectedPatient}
              />
            ) : (
              <PatientAppointmentsAndEditPatientControl
                appointment={appointment}
                mode={mode}
                {...restEditPatientProps}
              />
            )
          }
        />
      )}
    </StaffLayout>
  );
}
